import { pdf } from '@react-pdf/renderer';
import {OrderViewDTO} from "../types/dto";
import OrdersPDFTable from "../components/pdf/OrdersPDFTable";

export const usePDFGenerator = () => {
    const generatePDF = async (orderList: OrderViewDTO[]) => {
        const OrdersPDF = (
            <OrdersPDFTable orderList={orderList} />
        );

        const blob = await pdf(OrdersPDF).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'entregas.pdf';
        link.click();
    };

    return generatePDF;
};